import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLocale } from '../components/LocaleProvider';
import { SiteLayout } from '../components/SiteLayout';
export function WholesalePage() {
  const {
    locale
  } = useLocale();
  const text = locale === 'fr' ? {
    eyebrow: 'Clients professionnels',
    title: 'Votre partenaire hypermarché pour les besoins de grande ampleur.',
    body: 'Société Supermarches Charentais associe le choix d’un hypermarché complet à une équipe dédiée aux organisations, détaillants et acteurs de l’hôtellerie.',
    cta: 'Demande professionnelle',
    services: ['Commandes en volume & conteneurs', 'Approvisionnement entreprise & bureau', 'Hôtellerie & restauration', 'Écoles, hôpitaux & collectivités', 'Coordination import-export', 'Distribution nationale'],
    detail: 'Un accompagnement souple, de la demande d’information jusqu’à la livraison coordonnée.'
  } : {
    eyebrow: 'Business customers',
    title: 'Your hypermarket partner for larger requirements.',
    body: 'Société Supermarches Charentais combines the choice of a full hypermarket with a dedicated team for organisations, retailers and hospitality customers.',
    cta: 'Wholesale enquiry',
    services: ['Bulk & container orders', 'Corporate and office supply', 'Hotel & restaurant supply', 'Schools, hospitals & institutions', 'Import and export coordination', 'Nationwide distribution'],
    detail: 'Flexible support from product inquiry through coordinated fulfilment.'
  };
  return <>
      <SiteLayout data-id="element-264">
        <main data-id="element-265">
          <section className="bg-[#102b43] px-6 py-24 text-white" data-id="element-266">
            <div className="mx-auto max-w-[1100px]" data-id="element-267">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#7ee1df]" data-id="element-268">
                {text.eyebrow}
              </p>
              <h1 className="mt-5 max-w-3xl text-5xl font-extrabold tracking-[-0.05em]" data-id="element-269">
                {text.title}
              </h1>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300" data-id="element-270">
                {text.body}
              </p>
              <Link to="/contact" className="mt-8 inline-block rounded-lg bg-[#087c83] px-5 py-4 text-xs font-bold uppercase tracking-wider" data-id="element-271">
                {text.cta}
              </Link>
            </div>
          </section>
          <section className="mx-auto max-w-[1100px] px-6 py-20" data-id="element-272">
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-273">
              {text.services.map(service => <article key={service} className="border border-slate-200 bg-white p-6" data-id="element-274">
                  <CheckCircle2Icon className="text-[#087c83]" data-id="element-275" />
                  <h2 className="mt-4 font-extrabold text-[#102b43]" data-id="element-276">
                    {service}
                  </h2>
                  <p className="mt-2 text-sm leading-6 text-slate-500" data-id="element-277">
                    {text.detail}
                  </p>
                </article>)}
            </div>
          </section>
        </main>
      </SiteLayout>
    </>;
}